/* eslint-disable max-len */
import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import _ from 'lodash';

import metadata from './MLAgencySweepComponent.default.metadata.json5';
import styles from './MLAgencySweepComponent.module.scss';
import './MLAgencySweepComponent.messages';

// MLAgencySweep.js

function MLAgencySweepComponent(props) {
    const {
        id,
        onValidate,
        showValidationErrors,
        onModelChange,
        //
        sweepInfo, 
        paymentDetails,
    } = props;

    const {
        onValidate: setComponentValidation,
        isComponentValid
    } = useValidation(id);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const getAccountNumberDisplay = (accountNumber) => {
         const last4 = accountNumber.length > 3 ? accountNumber.slice(-4) : accountNumber;

         return `*****${last4}`;
    }

    const resolvers = {
        resolveClassNameMap: styles
    };

    const overrides = {
        routingNumber: {
            value: sweepInfo.routingNumber
        },
        accountNumber: {
            value: getAccountNumberDisplay(sweepInfo.accountNumber)
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={paymentDetails}
            overrideProps={overrides}
            onModelChange={onModelChange}
            onValidationChange={setComponentValidation}
            showErrors={showValidationErrors}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

MLAgencySweepComponent.propTypes = {
    id: PropTypes.string,
    onValidate: PropTypes.func,
    showValidationErrors: PropTypes.bool,
    //
    sweepInfo: PropTypes.shape({}).isRequired,
    paymentDetails: PropTypes.shape({}).isRequired
};

MLAgencySweepComponent.defaultProps = {
    id: undefined,
    onValidate: undefined,
    showValidationErrors: undefined
};

export default MLAgencySweepComponent;
